import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/base.component';
import { SuccessDto } from 'src/app/shared/models/success-dto';
import { AppStateInterface } from 'src/app/store/appState.interface';
import { invokeFranchiseFilter, invokeFranchisesCompanyNames } from 'src/app/store/franchise/franchise.action';
import { initialState } from 'src/app/store/franchise/franchise.reducers';
import { franchisesComapyNamesSelector } from 'src/app/store/franchise/franchise.selectors';
import { invokeLocationPartnersCompanyNames } from 'src/app/store/locationPartner/actions/get-locations.actions';
import { assignLPtoFranchiseSuccess, inovkeAssignLPToFranchise } from 'src/app/store/locationPartner/location-partner.action';
import { locationPartnersComapyNamesSelector, lpAssignedToFranchiseSelector } from 'src/app/store/locationPartner/location-partner.selectors';

@Component({
  selector: 'app-assign-franchised',
  templateUrl: './assign-franchised.component.html',
  styleUrls: ['./assign-franchised.component.scss']
})
export class AssignFranchisedComponent extends BaseComponent implements OnInit {
  form: FormGroup;

  allLPCompanyNames$: Observable<string[] | null>;
  resultAllLPCompanyNames: string[] | null;

  allFranchisesCompanyNames$: Observable<string[] | null>;
  resultAllFranchisesCompanyNames: string[] | null;

  lpAssignedToFranchise$: Observable<SuccessDto | null>;
  
  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private store: Store<AppStateInterface>,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) { 
    super(store);
    this.form = this.fb.group({
      location : new FormControl(null, [Validators.required]),
      franchise : new FormControl(null, [Validators.required]),
    });
    this.allLPCompanyNames$ = this.store
      .pipe(select(locationPartnersComapyNamesSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.allFranchisesCompanyNames$ = this.store
      .pipe(select(franchisesComapyNamesSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.lpAssignedToFranchise$ = this.store
      .pipe(select(lpAssignedToFranchiseSelector))
      .pipe(takeUntil(this.ngDestroyed$));
  }

  ngOnInit(): void {
    this.store.dispatch(invokeLocationPartnersCompanyNames({ excludeFranchised: true }));
    this.store.dispatch(invokeFranchisesCompanyNames());

    this.allLPCompanyNames$.subscribe((data) => {
      if (data) {
        this.resultAllLPCompanyNames = data;
      }
    });
    this.allFranchisesCompanyNames$.subscribe((data) => {
      if (data) {
        this.resultAllFranchisesCompanyNames = data;
      }
    });

    this.lpAssignedToFranchise$.subscribe((data) => {
      if (data) {
        this.toastr.success(
          this.translate.instant("response.success." + data.message),
          this.translate.instant("response.successTitle")
        );
        this.store.dispatch(
          invokeFranchiseFilter({
              franchiseFilter: initialState.franchiseFilter,
          })
        );
        this.modalService.dismissAll();
        this.store.dispatch(
          assignLPtoFranchiseSuccess({ successMessage: null })
        );
      }
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  assignFranchised() {
    const selectedLocation = this.form.get('location')?.value;
    const selectedFranchise = this.form.get('franchise')?.value;
    if (selectedLocation && selectedFranchise){
      this.store.dispatch(inovkeAssignLPToFranchise({ data: 
        {
          locations: selectedLocation, 
          franchise: selectedFranchise
        } 
     }));
    }
  }

}
